import React from 'react';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Link } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { FPSPhoneNumbers } from '../shared/Content';
import GenericError from '../shared/Errors/GenericError';

const CoClientEnrolled = () => {
    const errorSubText = (
        <Box>
            If you wish to join the service with a different partner, please contact us at{' '}
            <Link
                href={`tel:+${FPSPhoneNumbers.fpsSupportNumber}`}
                bold
            >
                {FPSPhoneNumbers.fpsSupportNumber}
            </Link>{' '}
            for assistance.
        </Box>
    );

    return (
        <Box
            sx={{
                backgroundColor: '#F4F5F6',
                inlineSize: 'unset',
                paddingTop: '80px',
                paddingBottom: '80px',
            }}
            className="b-container-content">
            <GenericError title="You have already started planning with us." id="enrolled-client">
                <Box sx={{ paddingBottom: '24px' }}>
                    For security reasons, a client may only engage with the service as part of one
                    household.
                </Box>
                <Box>{errorSubText}</Box>
            </GenericError>
        </Box>
    );
};

export default function CoClientEnrolledView() {
    return <CoClientEnrolled />;
}
